<template>
  <div>
    <view-table
        ref="viewTable"
        :filter="filter"
        :limits="limits"
        :columns-property="columnsProperty"
        module="basic"
        url="inspectionReports/pp"
        @select="selectHandle"
        @delete="deleteHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-button
            type="primary"
            :loading="exportLoading"
            @click="exportExcel()">
          导出
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
          <el-form-item label="编号">
            <el-input v-model.trim="filter.no" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.refBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="filter.status" clearable>
              <el-option label="草稿" :value="0"/>
              <el-option label="复检" :value="10"/>
              <el-option label="审核" :value="11"/>
              <el-option label="通过" :value="20"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料类型">
            <el-select
                v-model="materialTypeList"
                :popper-append-to-body="false"
                class="biddingStageSty"
                multiple
                clearable
                placeholder="请选择"
                @change="handleSelectMaterialtype">
              <el-option v-for="item in materialTypeOptions" :key="item.value" :label="item.name"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'startCreateDate', 'endCreateDate')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button
            v-if="addAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="submitHandle(scope.row)">
          提交
        </el-button>
        <el-button
            v-if="limits.approveAuth"
            type="primary"
            :disabled="scope.row.status !== 0"
            @click="approveHandle(scope.row)">
          审核
        </el-button>
      </template>
    </view-table>
    <!-- 编辑 -->
    <inspection-report-edit ref="inspectionReportEdit" @save-success="loadData"/>
  </div>
</template>

<script>
import ViewTable from "@/components/ViewTable.vue";
import InspectionReportEdit from "./InspectionReportEdit";

export default {
  name: "InspectionReportList",
  components: {
    ViewTable,
    InspectionReportEdit,
  },
  data() {
    return {
      limits: {
        detailAuth: this.$auth(521),
        editAuth: this.$auth(523),
        // addAuth: this.$auth(522),
        delAuth: this.$auth(524),
        approveAuth: this.$auth(489),
      },
      addAuth: this.$auth(522),
      importLoading: false,
      exportLoading: false,
      mainBoxHeight: 0,
      data: [],
      createDateRange: [],
      materialTypeList: [],
      materialTypeOptions: [],
      filterText: "",
      filter: {
        no: "",
        refBillNo: "",
        billType: -1,
        materialNo: "",
        materialName: "",
        specification: "",
        creatorName: "",
        status: "",
        startCreateDate: "",
        endCreateDate: "",
        materialTypeId: "",
        materialTypeIds: "",
      },
      columnsProperty: [
        {
          key: "no",
          align: "center",
          render: (h, params) => {
            return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.inspectionReportEdit.open(params.row, true, true);
                    },
                  },
                },
                params.row.no,
            );
          },
        },
        {
          key: "name",
          align: "center",
        },
        {
          key: "action",
          align: "center",
          width: 240,
          slot: "action",
          fixed: "right",
        },
      ],
      selection: [],
    };
  },
  watch: {
    "filter.startCreateDate": {
      handler(newVal) {
        if (newVal) {
          this.createDateRange = [];
          this.createDateRange.push(this.filter.startCreateDate);
          this.createDateRange.push(this.filter.endCreateDate);
        }
      },
    },
    "filter.materialTypeIds": {
      handler(val) {
        if (val) {
          this.materialTypeList = [];
          this.materialTypeOptions.map(item => {
            val.split(",").forEach((s) => {
              if (parseInt(s) === parseInt(item.value)) {
                this.materialTypeList.push(item.value);
              }
            });
          });
        }
      },
    },
  },
  created() {
    this.getMaterialTypeList();
  },
  methods: {
    getMaterialTypeList() {
      this.materialTypeOptions = [];
      this.$http.get("basic", "materialTypes/getAllList").then((res) => {
        if (res.success) {
          res.data.forEach((item) => {
            let temp = {"name": item.materialTypeName, "value": item.pkid};
            this.materialTypeOptions.push(temp);
          });
        }
      });
    },
    handleSelectMaterialtype(value) {
      if (value.length) {
        // this.materialTypeList = value;
        this.filter.materialTypeIds = value.join(",");
      } else {
        // this.materialTypeList = [];
        this.filter.materialTypeIds = "";
      }
    },
    dateRangeChange(timeRange, timeStart, timeEnd) {
      if (this[timeRange]) {
        this.filter[timeStart] = this[timeRange][0];
        this.filter[timeEnd] = this[timeRange][1];
      } else {
        this.filter[timeStart] = "";
        this.filter[timeEnd] = "";
      }
    },
    addEditHandle(row) {
      this.$refs.inspectionReportEdit.open(row, true, false);
    },

    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    exportExcel() {
      this.exportLoading = true;
      this.$http
          .exportFile("basic", "inspectionReports/export0", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
    },
    // 删除(单删、多删)
    deleteHandle(row) {
      this.$http.delete("basic", "inspectionReports", row.pkId).then((res) => {
        if (res.success) {
          this.loadData();
          this.$message.success("删除成功");
        }
      });
    },
    submitHandle(row) {
      this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", "inspectionReports/submit/" + row.pkId).then(() => {
          this.loadData(1);
          this.$message.success("提交成功");
          this.selection = [];
        });
      });
    },
    approveHandle(row) {
      this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", "productQualityApplications/approve/" + row.pkId).then(() => {
          this.loadData(1);
          this.$message.success("审核成功");
          this.selection = [];
        });
      });
    },
    // checkBox
    selectHandle(selection) {
      this.selection = selection;
    },
    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
    // 未提交、退单可以编辑删除
    otherAuth(row) {
      if (row.status === 0) {
        return {
          editAuth: false,
          delAuth: false,
        };
      } else {
        return {
          editAuth: true,
          delAuth: true,
        };
      }
    },
  },
};
</script>
<style scoped>
</style>

<style>
</style>
